import { type ComponentProps } from 'react';
import './Input.css';

interface InputProps extends ComponentProps<'input'> {
}

const Input = (props: InputProps) => {
  return (
    <input className="input" {...props} onKeyDown={(evt) => ["e", "E"].includes(evt.key) && props.type === "number" && evt.preventDefault()} />
  )
}

export default Input
